import { ErrorMessage } from '../contexts/message';
import Tracking from '../utils/tracking';

export const sendAlertShown = (
  path: string,
  message: string,
  error?: ErrorMessage | null,
): void => {
  Tracking.event('Alert shown', {
    message,
    path,
    // log raw message here for analytics
    raw_message: error?.message,
    code: error?.code,
  });
};
